import React from 'react';
import { Link } from 'react-router';
import { Dialog } from '@repo/ui/Dialog';
import { ButtonLink } from '@repo/ui/Button';
import type { Mercury } from '@repo/types/Models';
import SmsWithSegments, { ConcatenatedMessage } from './SmsWithSegments';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@repo/ui/UnstyledTabs';
import clsx from 'clsx';

export interface MessageBodyModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  sms: Mercury.Models.SMS;
}

const MessageBodyModal = ({ isOpen, setIsOpen, sms }: MessageBodyModalProps) => {
  return (
    <Dialog
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      title={`Message body`}
      description={`Segment: ${sms.id}`}
    >
      <div className="py-5">
        <Tabs defaultValue="full-message">
          <TabsList className="flex justify-start p-0 mb-4 w-full bg-transparent rounded-none border-b-2 dark:border-blue-900 border-grey-400">
            <TabsTrigger
              value="full-message"
              className={clsx(
                `px-2.5 -mb-1 !border-b-2 border-b-grey-400 rounded-b-none rounded-t-md cursor-pointer transition-colors text-grey-1000 dark:border-blue-400 mr-0 border-0 max-w-[200px] whitespace-nowrap dark:text-blue-100`,
                `hover:!bg-blue-200 hover:border-b-2 hover:border-b-blue-800`,
                `data-[state=active]:bg-transparent data-[state=active]:border-blue-800 data-[state=active]:font-bold`
              )}
            >
              Full Message
            </TabsTrigger>
            <TabsTrigger
              value="segments"
              className={clsx(
                `px-2.5 -mb-1 !border-b-2 border-b-grey-400 rounded-b-none rounded-t-md cursor-pointer transition-colors text-grey-1000 dark:border-blue-400 mr-0 border-0 max-w-[200px] whitespace-nowrap dark:text-blue-100`,
                `hover:!bg-blue-200 hover:border-b-2 hover:border-b-blue-800`,
                `data-[state=active]:bg-transparent data-[state=active]:border-blue-800 data-[state=active]:font-bold`
              )}
            >
              Segments
            </TabsTrigger>
          </TabsList>
          <TabsContent value="full-message" className="overflow-y-auto max-h-[50vh]">
            <ConcatenatedMessage primarySegment={sms} />
          </TabsContent>
          <TabsContent value="segments" className="overflow-y-auto max-h-[50vh]">
            <SmsWithSegments primarySegment={sms} inDialog={true} />
          </TabsContent>
        </Tabs>
        <div className="flex justify-end mt-4">
          <ButtonLink
            as={Link}
            size="sm"
            variant="secondary"
            icon="forum"
            href={`/a/${sms.account.id}/messaging/smses/${sms.id}?tab=Conversation`}
          >
            View in conversation
          </ButtonLink>
        </div>
      </div>
    </Dialog>
  );
};

export default MessageBodyModal;
